import { createApp } from 'vue'; // Vue 3 ile birlikte createApp kullanılır
import App from './App.vue';
import router from './router'; // Router'ı içe aktarın
import store from './store'; // Vuex store'u içe aktar
 
import './styles/main.css'; // Stil dosyasını dahil et
import '@mdi/font/css/materialdesignicons.css'; // İkon CSS dosyasını dahil et

import { createVuetify } from 'vuetify';
import 'vuetify/styles'; // Vuetify'ın varsayılan stillerini dahil et
import { aliases, mdi } from 'vuetify/iconsets/mdi'; // İkon setleri
import * as components from 'vuetify/components'; // Bileşenler
import * as directives from 'vuetify/directives'; // Direktifler


const vuetify = createVuetify({
  
  components,
    directives,
    icons: {
      defaultSet: 'mdi',
      aliases,
      sets: {
        mdi,
      },
    },
  });


const app = createApp(App); // createApp ile uygulamayı oluşturun
app.config.compilerOptions.isCustomElement = (tag) => {
  return ['v-list-item-icon', 'v-list-item-content', 'v-list-item-group'].includes(tag);
};
app.use(router); // Router'ı uygulamaya ekleyin
app.use(vuetify);
app.use(store);
 app.mount('#app'); // Uygulamayı mount edin
